<app-hero eyebrow="United Team Building"
          brandLogoSrc="assets/UTB-Logo.svg"
          brandLogoAlt="United Team Building"
          title="Experiences that bring teams together"
          subtitle="Corporate team building, onboarding support, and memorable events designed to strengthen teams and create lasting impact."
          primaryCtaLabel="Get Started"
          primaryCtaLink="/contact-us"
          secondaryCtaLabel="View Services"
          secondaryCtaLink="/services">
</app-hero>

<section class="home-section">
  <div class="container">
    <div class="section-heading">
      <p class="section-heading__eyebrow">What we do</p>
      <h2 class="section-heading__title js-title-reveal">Built for teams, leaders, and growing organizations</h2>
      <p class="section-heading__text">
        United Team Building helps organizations create better team experiences through curated activities,
        thoughtful onboarding support, and customer-focused event planning.
      </p>
    </div>

    <div class="feature-grid">
      <article class="feature-card">
        <h3>Team Building Experiences</h3>
        <p>Interactive events that improve collaboration, morale, and engagement.</p>
      </article>

      <article class="feature-card">
        <h3>Onboarding Support</h3>
        <p>Structured intake and communication flows that simplify onboarding experiences.</p>
      </article>

      <article class="feature-card">
        <h3>Client-Friendly Planning</h3>
        <p>Professional coordination that keeps experiences clear, smooth, and memorable.</p>
      </article>
    </div>
  </div>
</section>

<section class="home-section home-section--alt">
  <div class="container split-layout">
    <div>
      <p class="section-heading__eyebrow">Why United Team Building</p>
      <h2 class="section-heading__title js-title-reveal">Professional, polished, and practical</h2>
      <p class="section-heading__text">
        From initial inquiry through final coordination, the experience should feel organized, welcoming,
        and easy to navigate.
      </p>
      <a class="text-link" routerLink="/about-us">Learn more about us</a>
    </div>

    <div class="quote-card">
      <p class="quote-card__text">
        “We create experiences that help people connect better and organizations operate more smoothly.”
      </p>
    </div>
  </div>
</section>

<section class="home-section">
  <div class="container cta-panel">
    <div>
      <p class="section-heading__eyebrow">Ready to start?</p>
      <h2 class="section-heading__title js-title-reveal">Let’s create your next team experience</h2>
    </div>

    <div class="cta-panel__actions">
      <a class="button button--primary" routerLink="/contact-us">Contact Us</a>
      <a class="button button--secondary" routerLink="/services">Explore Services</a>
    </div>
  </div>
</section>
